import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CodaltComponent } from '../codalt.component';
import { Customer } from '../customer';
import { Filter } from '../filter';
import { PdfStyle } from '../pdf-style';
import { PdfStyleService } from '../pdf-style.service';
import { CustomerService } from '../services/customer/customer.service';
import { PageTitleService } from '../services/page-title/page-title.service';
import { WorkareaService } from '../services/workarea/workarea.service';
import { Workarea } from '../workarea.class';

@Component({
    selector: 'app-customer-list',
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.scss'],
    standalone: false,
})
export class CustomerListComponent extends CodaltComponent implements OnInit {
    childActive = false;
    customer: Customer;
    filter = new Filter();
    workareas: Workarea[];
    filteredWorkareas: Workarea[];
    type: string;
    workareaPerPage = false;
    pdfStyle: PdfStyle | null = null;
    pdfStyleKey: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private workareaService: WorkareaService,
        private pdfStyleService: PdfStyleService,
        private customerService: CustomerService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit() {
        this.setCustomerTitle();
        const styleKey = this.route.snapshot.queryParams['pdf_style'];
        if (styleKey) {
            this.pdfStyleKey = styleKey;
            this.pdfStyleService.getStyles().subscribe(styles => {
                this.pdfStyle = styles.find(s => s.key === styleKey) ?? null;
                this.pdfStyleService.applyPrimaryColor(this.pdfStyle);
            });
        }
        this.reload();
    }

    private parseWorkareaIds(rawValue: any): number[] {
        if (!rawValue || ['undefined', 'null'].includes(String(rawValue).toLowerCase())) {
            return [];
        }

        return String(rawValue)
            .split(',')
            .map((value: string) => +value)
            .filter((value: number) => value > 0);
    }

    public reload(reload = false) {
        Object.assign(this.filter, this.route.snapshot.queryParams);
        this.filter.normalizeLayers();
        if (this.filter.statuses) {
            this.filter.statuses = this.route.snapshot.queryParams.statuses?.split(',').map(p => +p) ?? [];
        }
        const rawWorkareaIds =
            this.route.snapshot.queryParams['workarea_ids'] ??
            this.route.snapshot.queryParams['workareaIds'] ??
            this.route.snapshot.queryParams['workareasIds'];
        this.filter.workarea_ids = this.parseWorkareaIds(rawWorkareaIds);
        if (
            this.route.snapshot.queryParams['workarea_per_page'] &&
            this.route.snapshot.queryParams['workarea_per_page'] === 'true'
        ) {
            this.workareaPerPage = true;
        }
        if (this.route.snapshot.queryParams?.workarea) {
            this.workareaService.getDetails(this.route.snapshot.queryParams?.workarea).then(workarea => {
                this.filteredWorkareas = [workarea];
                setTimeout(() => document.body.appendChild(document.createElement('readyforpuppeteer')), 1000);
            });
        } else {
            this.workareaService.getAll(reload, this.filter.statuses).then(workareas => {
                this.workareas = workareas;
                this.filterWorkareas(this.filter);
            });
        }
    }

    private filterWorkareas(filter: Filter) {
        if (this.workareas) {
            const filtered = filter.apply(this.workareas);
            if (filtered[0]) {
                this.type = filtered[0].type;
            }
            this.filteredWorkareas = filtered;
        }

        setTimeout(
            () => document.body.appendChild(document.createElement('readyforpuppeteer')),
            Math.min(25000, Math.max(2500, this.filteredWorkareas?.length * 60))
        );
    }

    areasTotal(areas) {
        let totalSize = 0;
        if (areas) {
            areas.forEach(area => {
                area.length = area.length > 0 ? area.length : 1;
                area.width = area.width > 0 ? area.width : 1;
                totalSize += area.width * area.length;
            });
        }
        return Math.round(totalSize * 100) / 100;
    }

    private setCustomerTitle() {
        this.pageTitleService.setTitle('Lijst klantgebied');
        this.watchRouteParams(this.RouteParamnames.customerId, ({ customerId }) => {
            if (customerId) {
                this.customerService
                    .getSingle(+customerId)
                    .subscribe(customer => this.pageTitleService.setTitle('Lijst klantgebied', customer.customer_name));
            }
        });
    }
}
